import React from 'react'
import "../MensData.js/ProductsShortsLower.css";
import p1 from "../assets/lower2.jpg";
import p2 from "../assets/p2.jpg";
import p3 from "../assets/p3.jpg";
import p4 from "../assets/p4.jpg";
import p5 from "../assets/p5.jpg";
import p6 from "../assets/p6.jpg";
export default function ProductsShortsLower() {

    const productsShortsLower = [
  {
    id: 1,
    name: "Model No.MG-25725-3",
    description: "Premium , Modern fit",
    image: p1,
    link: "/products/mens-short&Lowers1",
  },
  {
    id: 2,
    name: "Model No.MG-25725-11",
    description: "Premium , Modern fit",
    image: p2,
    link: "/products/mens-short&Lowers6",
  },
  {
    id: 3,
    name: "Model No.MG-25725-9",
    description: "Premium , Modern fit",
    image: p3,
    link: "/products/mens-short&Lowers2",
  },
  {
    id: 4,
    name: "Model No.MG-25725-4",
    description: "Premium , Modern fit",
    image: p4,
    link: "/products/mens-short&Lowers5",
  },
  {
    id: 5,
    name: "Model No.MG-25725-8",
    description: "Premium , Modern fit",
    image: p5,
    link: "/products/mens-short&Lowers3",
  },
  {
    id: 6,
    name: "Model No.MG-25725-11",
    description: "Premium , Modern fit",
    image: p6,
    link: "/products/mens-short&Lowers4",
  },
 
];
  return (
    <>
       <section className="psl">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Men’s Shorts & Lowers</h1>
      <div className="psl__grid">
        {productsShortsLower.map((p) => (
          <article key={p.id} className="psl__card">
            <img className="psl__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="psl__name">{p.name}</h3>
            <p className="psl__desc">{p.description}</p>
            <a className="psl__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>

    </>
  )
}
